/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-toggle-checkbox-checked-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.25 2.5H3.75c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V3.75c0-.69-.56-1.25-1.25-1.25zm-7.5 10.938l-3.125-3.126.994-.937 2.131 2.094 4.631-4.594.994.987-5.625 5.575z"/>'
  }
})
